import React from 'react';
import { Badge } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';

export const AISuggestedElementBadge = () => (
  <Badge data-component="AISuggestedElementBadge" variant="intelligence">
    <FormattedMessage defaultMessage="AI Suggested Element" id="6pb/7t" />
  </Badge>
);
